const BreadcrumbModule = {
  state: {
    breadcrumbs: [{name:'Dashboard', link:''}]
  },
  mutations: {
    updateBreadCrumb(state,breadcrumbs){
      state.breadcrumbs = breadcrumbs;
    }
  },
  actions: {
    updateBreadCrumbAction(context, breadcrumbs){
      context.commit('updateBreadCrumb', breadcrumbs);
    }
  }
};

export default BreadcrumbModule;
